import { render, staticRenderFns } from "./ChildIndustryDrawer.vue?vue&type=template&id=136dc22c&scoped=true"
import script from "./ChildIndustryDrawer.vue?vue&type=script&lang=js"
export * from "./ChildIndustryDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChildIndustryDrawer.vue?vue&type=style&index=0&id=136dc22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136dc22c",
  null
  
)

export default component.exports